import { useState, useCallback, useComponent, useEffect, useModel } from "../src/hooks";
import { Component } from "../src/component";

class TestModel {
    say() {
        console.log("hello");
    }
}

const ExamApp = () => {
    const [setTimeCount, getTimeCount ] = useState("timecount", 0);
    const obj = useModel(TestModel);
    useCallback(() => {
        setTimeCount(getTimeCount() + 1);
        obj.say();
    }, {name: "onClick", event: true});
    useEffect((name) => {
        console.log("event:", name);
    });
    console.log(obj);
    return `<a style="display: block; border-bottom: 1px solid gray; padding: 0 5px;">
        <button et:click="onClick" type="button">Update Time - {{state.timecount}}</button>
    </a>`;
}


export default () => {
    useComponent("ExamApp", ExamApp);
    return "<div style=\"background: gray;\">\n    <!-- <forEach data=\"state.listData\" item=\"sItem\" index=\"sKey\"> -->\n        <div em:for=\"let sItem in this.state.listData\" style=\"display: block;\" index=\"button\" key=\"forList\">\n            <button key=\"Item_{{button}}\">Event Handle - {{button}}</button>\n        </div>\n    <!-- </forEach> -->\n    <button em:if=\"{{showUpdate}}\" et:click=\"onClick\">Update</button>\n    <button et:click=\"onClick2\">New Update</button>\n    <div style=\"padding: 20px 0; background: green;\" data-value=\"Contaciner for Component\">\n        <div>\n            <ExamApp  title=\"Event Handler\"/>\n        </div>\n    </div>\n</div>";
};